const USER = 'user';
const SYSTEM = 'system';

export const LOGOUT_EVENT_TARGETS = Object.freeze({
  USER,
  SYSTEM
});
